import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { ChairVariantInfo } from "../api/hooks/useChairs";

type PDFContextType = {
    imageBlob: string;
    render: boolean;
    chairInfo: ChairVariantInfo | null;
    setImageBlob: (imageBlob: string) => void;
    setRender: (render: boolean) => void;
    setChairInfo: (chairInfo: ChairVariantInfo) => void;
};

export const usePDFContext = create<PDFContextType>()(
    persist(
        (set) => ({
            imageBlob: "",
            render: false,
            chairInfo: null,
            setImageBlob: (imageBlob) =>
                set(() => {
                    return { imageBlob: imageBlob };
                }),
            setRender: (render) =>
                set(() => {
                    return { render: render };
                }),
            setChairInfo: (chairInfo) =>
                set(() => {
                    return { chairInfo: chairInfo };
                }),
        }),
        {
            name: `at.meinstuhl.pdf`,
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ ...state, imageBlob: "" }),
        }
    )
);
